<template>
  <div class="footer">
    <div class="re-wrap foot-content">
      <div class="footer-all">
        <div class="foot-left">
          <div class="about widget">
            <p class="ul-title">关于知微</p>
            <p class="li-item">
              知微数据专注于互联网大数据情报监测分析领域，致力提升决策质量和效率，为品牌赋能。知微数据信奉长期主义和专业主义，持续升级和深化新技术、新理念与服务结合，与时代共同进化与成长。
            </p>
          </div>
          <div class="navis widget">
            <ul class="contact">
              <p class="ul-title">核心业务</p>
              <li class="li-item">
                <p title="知微舆情监测系统采用多机制协同的实时监测，精准判别内容调性，多维多层次揭示舆情；专业分析团队精准刻画传播影响，定位关键传播者，提炼核心观点，捕捉异常情况。">舆情监测分析</p>
              </li>
              <li class="li-item">
                <p title="知微数据助力分析挖掘品牌数据，洞察品牌声誉趋势；分析敌对/友好媒体，高效实现媒体资源管理。">竞争情报洞察</p>
              </li>
              <li class="li-item">
                <p title="倾听用户心声，了解用户的兴趣、诉求和痛点，拉近品牌与用户的距离。">市场用户研究</p>
              </li>
              <li class="li-item">
                <p title="知微数据整合企业精准标签数据，覆盖七大业务场景，构建企业舆情知识图谱。多维度搭建企业品牌舆情资产库，打造品牌自己的舆情搜索引擎。">数据资产管理</p>
              </li>
            </ul>
            <ul class="contact">
              <p class="ul-title">热门产品</p>
              <li class="li-item">
                <a
                  target="_blank"
                  href="https://ef.zhiweidata.com/"
                >知微事见</a>
              </li>
              <li class="li-item">
                <a
                  target="_blank"
                  href="https://crisis.zhiweidata.com/"
                >知微危机案例库</a>
              </li>
              <li class="li-item">
                <a
                  target="_blank"
                  href="https://brandkbs.zhiweidata.com/"
                >知微品见</a>
              </li>
              <li class="li-item">
                <p title="知微数见是一款针对品牌全网舆情监测平台，通过事件、品牌等关键词，对包括微博、微信公众号、网媒、贴吧、知乎、论坛、短视频等平台全网数据进行持续采集和分析，及时反馈用户重点关注舆情和提供专业舆情事件分析，让用户第一时间发现敏感舆情，持续跟进行业热点信息">知微数见</p>
              </li>
              <li class="li-item">
                <a
                  target="_blank"
                  href="http://weiboreach.com/index-main.html"
                >知微传播分析</a>
              </li>
            </ul>
            <ul class="contact">
              <p class="ul-title">联系我们</p>
              <li class="li-item">
                联系我们
                <img
                  src="@index/assets/footer/service-code.png"
                  alt=""
                >
              </li>
              <li class="li-item">
                商务合作
                <img
                  src="@index/assets/footer/service-code.png"
                  alt=""
                >
              </li>
              <li class="li-item">
                意见反馈
                <img
                  src="@index/assets/footer/service-code.png"
                  alt=""
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="foot-right">
          <ul class="code">
            <li class="li-code">
              <div class="ico">
                <p>
                  <i class="icon-sina-1"></i>
                </p>
                <h4>小程序</h4>
              </div>
              <div class="ewm-content">
                <div class="cont">
                  <img
                    src="@index/assets/footer/applets-code.jpg"
                    alt=""
                  >
                  <div class="right-text">
                    <p>
                      七大平台一站查询<br>
                      热搜资讯实时获取<br>
                      研究分析一键直达<br>
                    </p>
                  </div>
                </div>

              </div>
            </li>
            <li class="li-code">
              <div class="ico">
                <p>
                  <i class="icon-sina-2"></i>
                </p>
                <h4>微博</h4>
              </div>
              <div class="ewm-content">
                <div class="cont">
                  <img
                    src="@index/assets/footer/weibo-code.png"
                    alt=""
                  >
                  <div class="right-text">
                    <p>
                      热点分析、热搜榜单<br>
                      网络热梗、明星娱乐<br>
                      ……<br>
                      汇聚焦点新闻<br>
                      挖掘热点爆点<br>
                    </p>
                  </div>
                </div>

              </div>
            </li>
            <li class="li-code">
              <div class="ico">
                <p>
                  <i class="icon-sina-3"></i>
                </p>
                <h4>社群</h4>
              </div>
              <div class="ewm-content">
                <div class="cont">
                  <img
                    src="@index/assets/footer/followUpQrCode.png"
                    alt=""
                  >
                  <div class="right-text">
                    <p>
                      聚焦新消费<br>
                      关注新品牌<br>
                      洞察新趋势<br>
                      专属于新消费关注者
                    </p>
                  </div>
                </div>

              </div>
            </li>
            <li class="li-code">
              <div class="ico">
                <p>
                  <i class="icon-sina-4"></i>
                </p>
                <h4>公众号</h4>
              </div>
              <div class="ewm-content">
                <div class="cont">
                  <img
                    src="@index/assets/footer/wx-code.png"
                    alt=""
                  >
                  <div class="right-text">
                    <p>
                      全面观察热点动态<br>
                      专业解读上榜趋势<br>
                      实时查询行业热点<br>
                    </p>
                  </div>
                </div>

              </div>
            </li>
          </ul>
          <div class="footer-login">
            <img
              src="@index/assets/img/index/weijianliku.png"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="footer-phone">
        <div class="cont">
          <span>京ICP备13015804号-3</span>
          <p>
            邮箱：
            <a
              href="mailto:zhiwei@zhiweidata.com"
              class="email"
            >zhiwei@zhiweidata.com</a>
          </p>
          <p>
            电话：
            <a
              href="tel:400-811-3709"
              class="phone"
            >400-811-3709</a>
          </p>
          <p>
            QQ：
            <a
              href="tel:400-811-3709"
              class="phone"
            >2849888083</a>
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getCommunityQrCodeList } from '@/axios/api'
export default {
  data () {
    return {
      communityData: ''
    }
  },
  mounted () {
    // this.getData()
  },
  methods: {
    // getData () {
    //   getCommunityQrCodeList().then(res => {
    //     if (res.state) {
    //       this.communityData = res.data[0]
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 76px;
  background-color: #2a2a32;
  padding-top: 40px;
  .foot-content {
    &.re-wrap {
      margin: 0 auto;
      width: 1240px;
    }
    .footer-all {
      display: flex;
      justify-content: space-between;
    }
    .foot-left {
      display: flex;
      .widget::before {
        content: "";
        width: 0;
        height: 95%;
        border-left: 1px solid #33333c;
        position: absolute;
        right: 0;
        top: 5px;
      }
      .li-item {
        color: #949498;

        position: relative;

        &:hover img {
          display: block;
        }
        img {
          display: none;
          width: 60px;
          height: 60px;
          position: absolute;
          top: -60px;
          left: 50px;
        }
      }
      .about {
        width: 32%;
        // max-width: 470px;
        margin: 0;
        position: relative;
        padding-right: 30px;
        .li-item {
          line-height: 23px;
          height: 23px;
          font-size: 13px;
        }
      }
      .navis {
        position: relative;
        display: flex;
        justify-content: space-around;
        .contact {
          margin: 0 50px;
          text-align: center;
          .li-item {
            line-height: 22px;
            height: 22px;
            font-size: 12px;
          }
          li {
            color: #949498;
            cursor: pointer;
            &:hover {
              color: #fff;
            }
            a {
              color: #949498;
              &:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .ul-title {
      color: #fff;
      font-size: 18px;
      margin-bottom: 14px;
    }
    .foot-right {
      .footer-login {
        margin-top: 55px;
        text-align: center;
        img {
          height: 50px;
        }
      }
      ul {
        display: flex;
        li {
          cursor: pointer;
          position: relative;
          &:hover .ewm-content {
            display: block;
          }
          .ewm-content {
            display: none;
            .cont {
              width: 330px;
              background: #fff;
              border-radius: 6px;
              position: absolute;
              top: -175px;
              right: 0px;
              padding: 20px;
              display: flex;
            }
            .right-text {
              margin-left: 30px;
              flex: 1;
              padding-top: 20px;
              p {
                font-size: 14px;
                color: #666666;
                text-align: center;
              }
              .wei-code {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
                color: #28c445;
                font-size: 12px;
                i {
                  display: inline-block;
                  width: 16px;
                  height: 16px;
                  margin-right: 10px;
                  background: url("../assets/footer/community-wx.png") no-repeat;
                }
              }
            }
            img {
              width: 120px;
              height: 120px;
            }
          }
          .ico {
            text-align: center;
            h4 {
              font-size: 12px;
              color: #949498;
            }
            p {
              width: 60px;
              height: 32px;
              background: rgba(148, 148, 152, 0.15);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 6px 10px 6px;
              i {
                display: inline-block;
                width: 16px;
                height: 16px;

                background-size: 16px 16px;
              }
              .icon-sina-1 {
                background-image: url("../assets/footer/applets.png");
              }
              .icon-sina-2 {
                background-image: url("../assets/footer/weibo.png");
              }
              .icon-sina-3 {
                background-image: url("../assets/footer/digital.png");
              }
              .icon-sina-4 {
                background-image: url("../assets/footer/wx.png");
              }
            }
            &:hover .icon-sina-1 {
              background-image: url("../assets/footer/applets-active.png");
            }
            &:hover .icon-sina-2 {
              background-image: url("../assets/footer/weibo-active.png");
            }
            &:hover .icon-sina-3 {
              background-image: url("../assets/footer/digital-active.png");
            }
            &:hover .icon-sina-4 {
              background-image: url("../assets/footer/wx-active.png");
            }
            &:hover p {
              background: #fff;
            }
            &:hover h4 {
              color: #fff;
            }
          }
        }
      }
    }
    .footer-phone {
      width: 100%;
      align-items: flex-end;
      justify-content: center;
      margin-top: 40px;
      .cont {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        padding-bottom: 10px;
        width: 100%;
        border-top: 1px solid #33333c;
        span {
          color: #545454;
          font-size: 12px;
        }
        p {
          margin-left: 20px;
          color: #545454;
          font-size: 12px;
          display: flex;
          align-items: center;
          img {
            margin-right: 5px;
          }
          a {
            color: #545454;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/EventIndexFooter.vue